module.exports = __webpack_public_path__ + "img/close.cb65e057.png";